/* Les Passionnez — Empreintes olfactives (rendu SVG génératif côté client)
   Chaque élément .pz-emp[data-famille] reçoit une empreinte unique,
   déterminée par le nom de la note (data-note) et sa famille (data-famille). */
(function(){
"use strict";
function hash(s){let h=2166136261>>>0;for(let i=0;i<s.length;i++){h^=s.charCodeAt(i);h=Math.imul(h,16777619)>>>0;}return h>>>0;}
function mulberry32(a){return function(){a|=0;a=a+0x6D2B79F5|0;let t=Math.imul(a^a>>>15,1|a);t=t+Math.imul(t^t>>>7,61|t)^t;return((t^t>>>14)>>>0)/4294967296;};}
const f=n=>(Math.round(n*100)/100),P=(r,a)=>{const t=a*Math.PI/180;return[f(50+r*Math.cos(t)),f(50+r*Math.sin(t))];},ri=(g,lo,hi)=>lo+Math.floor(g()*(hi-lo+1));
let _u=0;
function dHesperidee(g,c){const n=ri(g,7,11),rot=g()*30,r0=9,r1=39;let s=`<circle cx="50" cy="50" r="${r1}" fill="none" stroke="${c}" stroke-width="1.1"/>`;for(let i=0;i<n;i++){const a=rot+i*360/n,[x0,y0]=P(r0,a),[x1,y1]=P(r1,a);s+=`<line x1="${x0}" y1="${y0}" x2="${x1}" y2="${y1}" stroke="${c}" stroke-width="1"/>`;}return s+`<circle cx="50" cy="50" r="${r0}" fill="none" stroke="${c}" stroke-width="1"/>`;}
function dFlorale(g,c){const n=ri(g,5,8),rot=g()*40,tip=38,base=9,w=(360/n)*(0.34+g()*0.12);let s='';for(let i=0;i<n;i++){const a=rot+i*360/n,[tx,ty]=P(tip,a),[lx,ly]=P(base,a-w),[rx,ry]=P(base,a+w),[cl,cly]=P(tip*.82,a-w*.8),[cr,cry]=P(tip*.82,a+w*.8);s+=`<path d="M${lx},${ly} Q${cl},${cly} ${tx},${ty} Q${cr},${cry} ${rx},${ry}" fill="none" stroke="${c}" stroke-width="1.05"/>`;}return s;}
function dFruitee(g,c){const n=ri(g,5,7),rot=g()*360;let s='';for(let i=0;i<n;i++){const a=rot+i*360/n+(g()-.5)*20,rr=20+g()*14,[cx,cy]=P(rr,a),rad=f(3.5+g()*3.5);s+=`<line x1="50" y1="50" x2="${cx}" y2="${cy}" stroke="${c}" stroke-width="0.7"/><circle cx="${cx}" cy="${cy}" r="${rad}" fill="none" stroke="${c}" stroke-width="1"/>`;}return s;}
function dGourmande(g,c){const turns=2.2+g()*.8,st=90,rM=38,dir=g()>.5?1:-1,rot=g()*360;let d='';for(let i=0;i<=st;i++){const t=i/st,ang=rot+dir*t*turns*360,r=6+t*rM,[x,y]=P(r,ang);d+=(i===0?'M':'L')+x+','+y+' ';}let s=`<path d="${d}" fill="none" stroke="${c}" stroke-width="1.15"/>`;const lp=ri(g,1,2);for(let i=0;i<lp;i++){const a=g()*360,[cx,cy]=P(30+g()*6,a);s+=`<circle cx="${cx}" cy="${cy}" r="${f(2.5+g()*2)}" fill="none" stroke="${c}" stroke-width="0.9"/>`;}return s;}
function dBoisee(g,c){const n=ri(g,4,6);let s='',r=12;for(let i=0;i<n;i++){r+=6+g()*3;const cx=f(50+(g()-.5)*4),cy=f(50+(g()-.5)*4);s+=`<circle cx="${cx}" cy="${cy}" r="${f(r)}" fill="none" stroke="${c}" stroke-width="${i===0?1.2:1}"/>`;}const sp=ri(g,3,5),rot=g()*90;for(let i=0;i<sp;i++){const a=rot+i*360/sp,[x0,y0]=P(8,a),[x1,y1]=P(r,a);s+=`<line x1="${x0}" y1="${y0}" x2="${x1}" y2="${y1}" stroke="${c}" stroke-width="0.7"/>`;}return s;}
function dOrientale(g,c){const n=ri(g,12,18),rot=g()*20;let s='';for(let i=0;i<n;i++){const a=rot+i*360/n,lg=i%2===0,r1=lg?40:30,[x0,y0]=P(11,a),[x1,y1]=P(r1,a);s+=`<line x1="${x0}" y1="${y0}" x2="${x1}" y2="${y1}" stroke="${c}" stroke-width="${lg?1:0.7}"/>`;}return s+`<circle cx="50" cy="50" r="10" fill="none" stroke="${c}" stroke-width="1.1"/><circle cx="50" cy="50" r="44" fill="none" stroke="${c}" stroke-width="0.8" stroke-dasharray="1 3"/>`;}
function dEpicee(g,c){const n=ri(g,6,9),rot=g()*40;let s='';for(let i=0;i<n;i++){const a=rot+i*360/n,[tx,ty]=P(40,a),[b1,b1y]=P(9,a-7),[b2,b2y]=P(9,a+7);s+=`<path d="M${b1},${b1y} L${tx},${ty} L${b2},${b2y}" fill="none" stroke="${c}" stroke-width="1"/>`;const[m,my]=P(26,a),[c1,c1y]=P(20,a-14),[c2,c2y]=P(20,a+14);s+=`<line x1="${c1}" y1="${c1y}" x2="${m}" y2="${my}" stroke="${c}" stroke-width="0.7"/><line x1="${c2}" y1="${c2y}" x2="${m}" y2="${my}" stroke="${c}" stroke-width="0.7"/>`;}return s;}
function dAromatique(g,c){const n=ri(g,3,5),sp=90,rot=g()*30;let s='';for(let i=0;i<n;i++){const a=270-sp/2+i*sp/(n-1)+rot*.2,[tx,ty]=P(40,a),[cx,cy]=P(24,a+(g()>.5?12:-12));s+=`<path d="M50,58 Q${cx},${cy} ${tx},${ty}" fill="none" stroke="${c}" stroke-width="1.05"/>`;for(let j=1;j<=2;j++){const t=.45+j*.22,mx=f(50+(tx-50)*t),my=f(58+(ty-58)*t);s+=`<line x1="${mx}" y1="${my}" x2="${f(mx-4)}" y2="${f(my-5)}" stroke="${c}" stroke-width="0.7"/><line x1="${mx}" y1="${my}" x2="${f(mx+4)}" y2="${f(my-5)}" stroke="${c}" stroke-width="0.7"/>`;}}return s;}
function dVerte(g,c){const rot=g()*360,len=40,pr=ri(g,4,6),[tx,ty]=P(len,rot),[bx,by]=P(len*.9,rot+180);let s=`<line x1="${bx}" y1="${by}" x2="${tx}" y2="${ty}" stroke="${c}" stroke-width="1.2"/>`;for(let i=1;i<=pr;i++){const t=i/(pr+1),px=f(bx+(tx-bx)*t),py=f(by+(ty-by)*t),[l1,l1y]=P(14,rot+55),[l2,l2y]=P(14,rot-55);s+=`<line x1="${px}" y1="${py}" x2="${f(px+(l1-50)*.7)}" y2="${f(py+(l1y-50)*.7)}" stroke="${c}" stroke-width="0.8"/><line x1="${px}" y1="${py}" x2="${f(px+(l2-50)*.7)}" y2="${f(py+(l2y-50)*.7)}" stroke="${c}" stroke-width="0.8"/>`;}return s;}
function dChypree(g,c){const n=ri(g,3,5),rot=g()*30;let s='',r=12;for(let i=0;i<n;i++){r+=7+g()*2;const pts=[P(r,rot),P(r,rot+90),P(r,rot+180),P(r,rot+270)].map(p=>p.join(',')).join(' ');s+=`<polygon points="${pts}" fill="none" stroke="${c}" stroke-width="${i===0?1.2:.95}"/>`;}return s;}
function dMusquee(g,c){const rings=ri(g,3,4),k=ri(g,5,8),amp=1.6+g()*1.4,rot=g()*360;let s='';for(let j=0;j<rings;j++){const base=14+j*8;let d='';for(let a=0;a<=360;a+=6){const r=base+amp*Math.sin((a+rot)*k*Math.PI/180),[x,y]=P(r,a);d+=(a===0?'M':'L')+x+','+y+' ';}d+='Z';s+=`<path d="${d}" fill="none" stroke="${c}" stroke-width="${j===0?1.1:.9}"/>`;}return s;}
function dCuiree(g,c,uid){const id='pzc'+uid,n=ri(g,4,6),step=76/n;let s=`<defs><clipPath id="${id}"><circle cx="50" cy="50" r="40"/></clipPath></defs><g clip-path="url(#${id})">`;for(let i=0;i<=n;i++){const o=12+i*step;s+=`<line x1="${f(o)}" y1="10" x2="${f(o-30)}" y2="90" stroke="${c}" stroke-width="0.9"/><line x1="${f(100-o)}" y1="10" x2="${f(100-o+30)}" y2="90" stroke="${c}" stroke-width="0.9"/>`;}return s+'</g>';}
function dMarine(g,c,uid){const id='pzm'+uid,lines=ri(g,4,6),k=ri(g,2,4),amp=3+g()*2,rot=g()*10;let s=`<defs><clipPath id="${id}"><circle cx="50" cy="50" r="40"/></clipPath></defs><g clip-path="url(#${id})">`;const gap=80/(lines+1);for(let j=0;j<lines;j++){const y0=15+j*gap;let d='';for(let x=8;x<=92;x+=4){const y=y0+amp*Math.sin((x+rot+j*18)*k*Math.PI/180);d+=(x===8?'M':'L')+f(x)+','+f(y)+' ';}s+=`<path d="${d}" fill="none" stroke="${c}" stroke-width="1.05"/>`;}return s+'</g>';}
const FAM={hesperidee:{c:'#C6A150',d:dHesperidee},florale:{c:'#B08478',d:dFlorale},fruitee:{c:'#9E4A42',d:dFruitee},gourmande:{c:'#A9713C',d:dGourmande},boisee:{c:'#5A3620',d:dBoisee},orientale:{c:'#B5763A',d:dOrientale},epicee:{c:'#A85236',d:dEpicee},aromatique:{c:'#7C7A45',d:dAromatique},verte:{c:'#5E6B45',d:dVerte},chypree:{c:'#6E6A3E',d:dChypree},musquee:{c:'#8C7A63',d:dMusquee},cuiree:{c:'#6B4A2E',d:dCuiree},marine:{c:'#5F7E7C',d:dMarine}};
const ALIAS={hesperidée:'hesperidee','hespéridée':'hesperidee',agrumes:'hesperidee',fruitée:'fruitee',boisée:'boisee',épicée:'epicee',orientale:'orientale',ambrée:'orientale',ambree:'orientale',verte:'verte',chyprée:'chypree',musquée:'musquee',cuirée:'cuiree',aldehyde:'aromatique',aromatique:'aromatique',fougere:'aromatique','fougère':'aromatique',poudree:'florale','poudrée':'florale'};
function norm(k){k=(k||'').toString().trim().toLowerCase();return FAM[k]?k:(ALIAS[k]||'florale');}
function empreinte(note,famille,color){
  const fk=norm(famille),fam=FAM[fk],c=color||fam.c,uid=++_u;
  const g=mulberry32(hash((note||fk).toLowerCase()+'|'+fk)),inner=fam.d(g,c,uid);
  return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-label="${note||fk}"><g stroke-linecap="round" stroke-linejoin="round"><circle cx="50" cy="50" r="47" fill="none" stroke="${c}" stroke-width="0.6" opacity="0.28"/>${inner}<circle cx="50" cy="50" r="1.6" fill="${c}"/></g></svg>`;
}
function renderAll(root){
  (root||document).querySelectorAll('.pz-emp[data-famille]').forEach(function(el){
    if(el.dataset.done)return;el.dataset.done='1';
    el.innerHTML=empreinte(el.dataset.note,el.dataset.famille,el.dataset.color||null);
  });
}
function reveals(){
  var els=document.querySelectorAll('.pz-reveal');if(!('IntersectionObserver'in window)||!els.length){els.forEach(function(e){e.classList.add('in');});return;}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.1});
  els.forEach(function(e){io.observe(e);});
}
window.PZ={empreinte:empreinte,render:renderAll};
document.addEventListener('DOMContentLoaded',function(){renderAll();reveals();});
// Re-render after Shopify section reload (theme editor)
document.addEventListener('shopify:section:load',function(e){renderAll(e.target);reveals();});
})();

/* ==================================================================
   PZ · Flèches de galerie sur la fiche produit
   À COLLER TEL QUEL À LA FIN DE  assets/passionnez.js

   Pourquoi ce bout de code : sur desktop, Dawn n'affiche qu'une image
   à la fois et confie la navigation aux vignettes. Ses flèches natives
   ne savent donc pas avancer (elles font défiler un rail qui ne défile
   pas). On les rebranche sur les vignettes, qui sont la vraie commande.
   Sur mobile le rail défile pour de bon : on ne touche à rien.
   ================================================================== */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 990px)';

  function isDesktop() {
    return window.matchMedia && window.matchMedia(DESKTOP).matches;
  }

  function thumbsOf(gallery) {
    return Array.prototype.slice.call(
      gallery.querySelectorAll('.thumbnail-list__item button.thumbnail')
    );
  }

  function currentIndex(list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }

  /* Le compteur « 2 / 4 » est géré par Dawn à partir du défilement :
     sur desktop il ne bouge pas, on le tient à jour nous-mêmes. */
  function syncCounter(gallery) {
    var list = thumbsOf(gallery);
    if (list.length < 2) return;
    var cur = gallery.querySelector('.slider-counter--current');
    var tot = gallery.querySelector('.slider-counter--total');
    if (cur) cur.textContent = currentIndex(list) + 1;
    if (tot) tot.textContent = list.length;
  }

  /* Dawn désactive prev/next selon la position du rail. Sur desktop ce
     calcul est faux : on garde les deux boutons actifs et on boucle. */
  function keepEnabled(gallery) {
    var btns = gallery.querySelectorAll('.slider-buttons .slider-button[disabled]');
    Array.prototype.forEach.call(btns, function (b) {
      b.removeAttribute('disabled');
    });
  }

  function move(gallery, step) {
    var list = thumbsOf(gallery);
    if (list.length < 2) return;
    var next = (currentIndex(list) + step + list.length) % list.length;
    list[next].click();
    window.setTimeout(function () {
      syncCounter(gallery);
      keepEnabled(gallery);
    }, 60);
  }

  /* Capture : on passe avant le gestionnaire de slider-component. */
  document.addEventListener('click', function (e) {
    if (!isDesktop()) return;
    var node = e.target;
    if (!node || !node.closest) return;
    var btn = node.closest('.slider-buttons .slider-button');
    if (!btn) return;
    var gallery = btn.closest('media-gallery');
    if (!gallery) return;
    e.preventDefault();
    e.stopPropagation();
    move(gallery, btn.getAttribute('name') === 'next' ? 1 : -1);
  }, true);

  function setup(root) {
    var galleries = (root || document).querySelectorAll('media-gallery');
    Array.prototype.forEach.call(galleries, function (gallery) {
      if (gallery.dataset.pzArrows === '1') return;
      gallery.dataset.pzArrows = '1';

      syncCounter(gallery);
      if (isDesktop()) keepEnabled(gallery);

      /* Dawn remet « disabled » quand il recalcule : on repasse derrière. */
      var bar = gallery.querySelector('.slider-buttons');
      if (bar && window.MutationObserver) {
        new MutationObserver(function () {
          if (isDesktop()) keepEnabled(gallery);
        }).observe(bar, {
          attributes: true,
          subtree: true,
          attributeFilter: ['disabled']
        });
      }

      /* Clic direct sur une vignette : le compteur suit. */
      gallery.addEventListener('click', function (ev) {
        if (ev.target.closest && ev.target.closest('.thumbnail-list__item')) {
          window.setTimeout(function () { syncCounter(gallery); }, 60);
        }
      });
    });
  }

  function boot() { setup(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Rechargement d'une section depuis le personnalisateur. */
  document.addEventListener('shopify:section:load', function (e) {
    setup(e.target || document);
  });

  window.addEventListener('resize', function () {
    if (isDesktop()) {
      Array.prototype.forEach.call(
        document.querySelectorAll('media-gallery'),
        function (g) { keepEnabled(g); syncCounter(g); }
      );
    }
  });
})();

/* ==================================================================
   PZ · Galerie produit sur mobile
   À COLLER À LA FIN DE  assets/passionnez.js

   Sous 990 px, la galerie de Dawn est un rail qui défile au doigt,
   mais ni les flèches ni les vignettes ne le déplacent : le clic
   marque la vignette active sans bouger l'image. Ce bloc rebranche
   les deux sur le rail, et tient le compteur à jour quand on swipe.
   ================================================================== */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 990px)';

  function isDesktop() {
    return window.matchMedia && window.matchMedia(DESKTOP).matches;
  }

  function railOf(gallery) {
    return gallery.querySelector('.product__media-list');
  }

  function itemsOf(gallery) {
    return Array.prototype.slice.call(
      gallery.querySelectorAll('.product__media-item')
    );
  }

  function thumbsOf(gallery) {
    return Array.prototype.slice.call(
      gallery.querySelectorAll('.thumbnail-list__item button.thumbnail')
    );
  }

  /* Quelle image est devant ? La plus proche de la position du rail. */
  function currentIndex(gallery) {
    var rail = railOf(gallery);
    var items = itemsOf(gallery);
    if (!rail || !items.length) return 0;
    var base = items[0].offsetLeft;
    var x = rail.scrollLeft;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < items.length; i++) {
      var d = Math.abs(items[i].offsetLeft - base - x);
      if (d < bestDist) { bestDist = d; best = i; }
    }
    return best;
  }

  /* Le défilement animé est annulé par le thème : on saute net. */
  function goTo(gallery, n) {
    var rail = railOf(gallery);
    var items = itemsOf(gallery);
    if (!rail || !items[n]) return;
    var previous = rail.style.scrollBehavior;
    rail.style.scrollBehavior = 'auto';
    rail.scrollLeft = items[n].offsetLeft - items[0].offsetLeft;
    window.requestAnimationFrame(function () {
      rail.style.scrollBehavior = previous || '';
    });
    sync(gallery);
  }

  function sync(gallery) {
    var i = currentIndex(gallery);
    var items = itemsOf(gallery);
    var thumbs = thumbsOf(gallery);
    var cur = gallery.querySelector('.slider-counter--current');
    var tot = gallery.querySelector('.slider-counter--total');
    if (cur) cur.textContent = i + 1;
    if (tot) tot.textContent = items.length;
    for (var k = 0; k < thumbs.length; k++) {
      thumbs[k].setAttribute('aria-current', k === i ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (e) {
    if (isDesktop()) return;
    var node = e.target;
    if (!node || !node.closest) return;

    var gallery = node.closest('media-gallery');
    if (!gallery) return;

    var arrow = node.closest('.slider-buttons .slider-button');
    if (arrow) {
      e.preventDefault();
      e.stopPropagation();
      var total = itemsOf(gallery).length;
      var step = arrow.getAttribute('name') === 'next' ? 1 : -1;
      goTo(gallery, (currentIndex(gallery) + step + total) % total);
      return;
    }

    var thumb = node.closest('.thumbnail-list__item');
    if (thumb) {
      e.preventDefault();
      e.stopPropagation();
      var all = Array.prototype.slice.call(
        gallery.querySelectorAll('.thumbnail-list__item')
      );
      goTo(gallery, all.indexOf(thumb));
    }
  }, true);

  function setup(root) {
    var galleries = (root || document).querySelectorAll('media-gallery');
    Array.prototype.forEach.call(galleries, function (gallery) {
      if (gallery.dataset.pzMobile === '1') return;
      gallery.dataset.pzMobile = '1';

      var rail = railOf(gallery);
      if (!rail) return;

      /* Le doigt fait défiler : le compteur et la vignette suivent. */
      var timer;
      rail.addEventListener('scroll', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          if (!isDesktop()) sync(gallery);
        }, 120);
      });

      if (!isDesktop()) sync(gallery);
    });
  }

  function boot() { setup(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    setup(e.target || document);
  });
})();

/* ==================================================================
   PZ · PASSE 8 — Cartes du méga-menu reprises dans le tiroir mobile
   Les cartes existent déjà dans le DOM (menu desktop masqué sous
   990px). On les clone en tête du sous-menu correspondant et on
   masque les liens texte devenus redondants.
   ================================================================== */
(function () {
  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function enrichirTiroir() {
    var source = {};
    document.querySelectorAll('.lpm header-menu').forEach(function (hm) {
      var titre = hm.querySelector('summary');
      var panneau = hm.querySelector('.lpm__edito-feat');
      if (titre && panneau) source[norm(titre.textContent)] = panneau;
    });

    document.querySelectorAll('.menu-drawer__submenu').forEach(function (sub) {
      if (sub.querySelector('.lpmd__feat')) return;

      var parent = sub.closest('details');
      var titre = parent ? parent.querySelector('summary') : null;
      if (!titre) return;

      var panneau = source[norm(titre.textContent)];
      if (!panneau) return;

      var liste = sub.querySelector('ul.menu-drawer__menu');
      if (!liste) return;

      var box = document.createElement('div');
      box.className = 'lpmd__feat';
      var liens = [];
      panneau.querySelectorAll('.lpm__feat').forEach(function (carte) {
        box.appendChild(carte.cloneNode(true));
        liens.push(carte.getAttribute('href'));
      });
      if (!box.children.length) return;

            liste.parentNode.appendChild(box);

      Array.prototype.forEach.call(liste.children, function (li) {
        var a = li.querySelector('a');
        if (a && liens.indexOf(a.getAttribute('href')) > -1) {
          li.setAttribute('data-lpmd-dup', '1');
        }
      });
    });
  }

  enrichirTiroir();
  document.addEventListener('shopify:section:load', enrichirTiroir);
})();